import { tryFocus } from '@/utils';
import {
	SvgIcon,
	useBlockStore,
	useFormStore,
	useJsEvents,
	useIntegrations,
	useProperties
} from '@/features/form';
import HandleTabIndex from './HandleTabIndex';

export default function Link({ children, block, ...props }) {
	const { properties = {} } = block;
	const { conversational } = useProperties();
	const { actions: blockStateActions } = useBlockStore();
	const { contentDivRef, formIsCompleted, actions, currentConversationalFocusRef } =
		useFormStore();
	const triggerEvent = useJsEvents();
	const integrations = useIntegrations();

	const parse = () => {
		//Get the string that should be link -> todo: this should already be passed down from the config
		let linkStr =
			properties.hyperlinktext &&
			properties.hyperlinktext.match(/\/\*(.*)\*\//gi) &&
			properties.hyperlinktext
				.match(/\/\*(.*)\*\//gi)[0]
				.replace('/*', '')
				.replace('*/', '');
		let linkAttr = {};
		let linkIcon;
		if (properties.linktype === 'function') {
			linkAttr.onClick = e => {
				e.preventDefault();
				if (properties.linktype_function === 'next_page') {
					actions.nextPage();
				} else if (properties.linktype_function === 'prev_page') {
					actions.prevPage();
				} else if (
					['close_modal', 'close_embedded', 'close'].indexOf(
						properties.linktype_function
					) > -1
				) {
					actions.toggleForm(false);
				} else if (properties.linktype_function === 'start') {
					if (!formIsCompleted) {
						actions.startForm();
					}
					if (formIsCompleted || conversational) {
						blockStateActions.reset();
					}
					tryFocus(contentDivRef.current);
				}
			};

			if (!properties.show_as_buttons && properties.link_style !== 'button') {
				linkAttr.role = 'button';
				linkAttr.href = '#';
			}
		} else {
			//Check if url contains protocol or starts with a slash (relative) otherwise prepend protocol
			let linkUrl =
				properties.hyperlinkhref &&
				(properties.hyperlinkhref.match(/((http(s?)))/gi) ||
					properties.hyperlinkhref.charAt(0) === '/')
					? properties.hyperlinkhref
					: `${properties.hyperlinkprotocol}${properties.hyperlinkhref}`;
			linkAttr.href = linkUrl;
			linkAttr.target = properties.target ?? '_blank';
			linkAttr.onClick = () => {
				triggerEvent('redirect', { url: linkUrl });
				integrations.sendEvent('redirect');
				if (properties.close_on_linkclick) {
					actions.toggleForm(false);
				}
			};
		}
		linkAttr.class = properties.show_as_panels
			? 'panel'
			: properties.show_as_buttons || properties.link_style === 'button'
			? 'btn'
			: '';
		linkIcon =
			(properties.show_as_panels ||
				properties.show_as_buttons ||
				properties.link_style === 'button') &&
			properties.icon ? (
				<SvgIcon icon={properties.icon} />
			) : (
				''
			);

		return (
			<span>
				{properties.description.split(linkStr).reduce((prev, current, i) => {
					if (!i) {
						return [current];
					}
					return prev.concat(
						<HandleTabIndex
							component={
								(properties.show_as_buttons && properties.linktype === 'function') ||
								(properties.link_style === 'button' && properties.linktype === 'function')
									? 'button'
									: 'a'
							}
							{...linkAttr}
						>
							{properties.iconAlignment !== 'right'
								? [linkIcon, linkStr]
								: [linkStr, linkIcon]}
						</HandleTabIndex>,
						current
					);
				}, [])}
			</span>
		);
	};

	return (
		<div
			id={`link_${block.id}`}
			class="link_block"
			ref={currentConversationalFocusRef}
		>
			{parse()}
		</div>
	);
}
